<template>
  <section style="margin: 2em 0;">
    <h3>DDHQ Poll Average: <span class="poll-average" :style="`color: ${pollAverageColor};`">{{ computedPollAverage }}</span></h3>

    <v-data-table
      :headers="tableHeaders"
      :items="tableItems"
      :items-per-page="5"
      :dense="mobile"
      sort-by="endDate"
      :sort-desc="true">
      <template #item.name="{item}">
        <a
          v-if="item.link"
          :href="item.link"
          target="_blank">
          {{ item.name }}
        </a>

        <span v-else>{{ item.name }}</span>
      </template>

      <template #item.startDate="{item}">
        {{ item.startDate | date }}
      </template>

      <template #item.endDate="{item}">
        {{ item.endDate | date }}
      </template>

      <template #item.republicanPercentage="{item}">
        {{ item.republicanPercentage }}%
      </template>

      <template #item.democratPercentage="{item}">
        {{ item.democratPercentage }}%
      </template> -->

      <template #item.margin="{item}">
        <span :style="`color: ${marginColor(item.margin)};`">{{ item.margin }}</span>
      </template>
    </v-data-table>

    <div class="legend">
      <p>M = Margin</p>
      <p>Pop = Population</p>
      <p>N = Sample Size</p>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

const props = {
  pollAverage: {
    default: "D+3.1",
    required: true,
  },
  tableItems: {
    required: true,
    type: Array,
  },
};

const computed = {
  ...mapGetters({
    screenWidth: "ux/screenWidth",
    mobile: "ux/mobile",
  }),
  computedPollAverage() {
    if (this.pollAverage !== null) return this.pollAverage;
    return "N/A";
  },
  pollAverageColor() {
    if (this.computedPollAverage.includes("R")) return this.gopColor;
    if (this.computedPollAverage.includes("D")) return this.demColor;
    return "inherit";
  },
};

const methods = {
  marginColor(margin) {
    if (margin.includes("R")) return this.gopColor;
    if (margin.includes("D")) return this.demColor;
    return "inherit";
  },
};

export default {
  props,
  computed,
  methods,
  data: () => ({
    gopColor: "#d84b44",
    demColor: "#4575a1",
    tableHeaders: [
      {
        align: "start",
        text: "Pollster",
        value: "name",
      },
      {
        text: "Start Date",
        value: "startDate",
      },
      {
        text: "End Date",
        value: "endDate",
      },
      {
        text: "GOP",
        value: "republicanPercentage",
        width: 75,
      },
      {
        text: "Dem",
        value: "democratPercentage",
        width: 75,
      },
      {
        text: "M",
        value: "margin",
        width: 80,
      },
      {
        text: "Pop",
        value: "population",
      },
      {
        align: "end",
        text: "N",
        value: "sampleSize",
        width: 60,
      },
    ],
  }),
};
</script>

<style scoped>
h3 {
  margin: 1em 0;
}

.poll-average {
  font-weight: 700;
  text-decoration: underline;
}

.legend {
  font-size: .8rem;
  font-style: italic;
  text-align: right;
}

.legend p {
  margin: 0;
}

.v-data-table-header th {
  white-space: nowrap;
}

.v-data-table /deep/ td {
  min-height: 2.5em;
}
</style>
